import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { PreventiveMaintenanceStandaloneService } from 'src/app/_services/preventive-maintenance-standalone.service';
import { ErrorUtil } from 'src/app/_utilities/error';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import moment from "moment-timezone";
import { AuthenticationService } from 'src/app/auth/authentication.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-clone-plan',
    templateUrl: './clone-plan.component.html',
    styleUrls: ['./clone-plan.component.scss'],
    standalone: false
})
export class ClonePlanComponent extends SubscriptionUtil implements OnInit, OnDestroy {
  data: any
  addPlanForm!: UntypedFormGroup; // <-- parent form group
tomorrow!: Date; // minimum date for start date picker
minDateForEndDate: Date; // minimum date for end date picker
//****************************************** Set up Update Mode *****************************
 
  cloneData:any={
    id: null,
    name: null,
    startDateTime: '',
    endOption: 'NEVER',
    endDateTime:null,
    cloneAssetOrSites: false
  }
  /****************************************** End Set up Update Mode *****************************/
  endTimeOptions:any = [
  { label: 'After 6 Months', value: 'AFTER_6_MONTHS', calcMonths: 6 },
  { label: 'After 1 Year',   value: 'AFTER_1_YEAR',   calcMonths: 12 },
  { label: 'After 2 Years',  value: 'AFTER_2_YEARS',  calcMonths: 24 },
  { label: 'After 3 Years',  value: 'AFTER_3_YEARS',  calcMonths: 36 },
  { label: 'Never End',      value: 'NEVER',          calcMonths: null },
  { label: 'On Date',    value: 'CUSTOM_DATE', calcMonths: 0 }
];
  translate: any;
  viewUrl: string;

  constructor(
    public modalRef: BsModalRef,
    private preventiveMaintenanceStandaloneService: PreventiveMaintenanceStandaloneService,
    private languageTranslateService: LanguageTranslateService,
    private spinner: NgxSpinnerService,
    private errorUtil: ErrorUtil,
    private auth: AuthenticationService,
     private router: Router
  ) { 
     super();  
     
  }

  ngOnInit(): void {
    console.log(this.data);
      this.cloneData.id = this.data.id;
     if(this.data.planType == 'ASSET'){
            this.viewUrl = 'dashboard/preventative-maintenance-standalone/assetsList'
          } else if(this.data.planType == 'SITE'){
            this.viewUrl = 'dashboard/preventative-maintenance-standalone/sitesList'
           
          }else{
            this.viewUrl = 'dashboard/preventative-maintenance-standalone/recurringList'
          }

    this.getLanguageData();
  }
  /****************************************** End Set up Update Mode *****************************/
getLanguageData() {
  this.push(
    this.languageTranslateService.wordSrc$.subscribe((data) => {
      if (Object.keys(data).length != 0) {
        this.translate = data;
       this.buildForm();
      this.getFutureDate(); 
      }
    })
  );
}
/****************************************** Get Future Date *****************************/
getFutureDate() {
  const t = new Date();
     t.setHours(0,0,0,0);
    t.setDate(t.getDate());
    this.tomorrow = t;
}
/****************************************** End handleChangedData *****************************/
 buildForm() {

         this.addPlanForm  = new UntypedFormGroup({
        name: new UntypedFormControl(null, [Validators.required]),
        startDateTime: new UntypedFormControl(null, [Validators.required]),
        endOption: new UntypedFormControl(null,[Validators.required]),
        endDateTime: new UntypedFormControl(null),
        });

    this.addPlanForm.get('startDateTime')!.valueChanges.subscribe((start: Date | string | null) => {
      const opt = this.getEndOpt(this.addPlanForm.get('endOption')!.value);
      if (!opt?.calcMonths || !start) return;

      const startDate = new Date(start);
      const auto = this.addMonths(startDate, opt.calcMonths);
      this.cloneData.endDateTime = auto;
      //this.getEndDateMin();
      this.addPlanForm.get('endDateTime')!.setValue(auto, { emitEvent: false });
    });

  }
  getEndDateMin(): Date | null {
    const start = this.addPlanForm?.get('startDateTime')?.value;
    if (!start) return null;
    const minDate = new Date(start);
   // minDate.setMonth(minDate.getMonth() + 1);
    this.minDateForEndDate = minDate;
  }
  /****************************************** End handleChangedData *****************************/
  private getEndOpt(val: any) {
  return this.endTimeOptions.find(o => o.value === val) as
    | { value: string; calcMonths?: number; requiresDate?: boolean }
    | undefined;
}
/****************************************** Change End Option *****************************/
private addMonths(base: Date, months: number): Date {
  const d = new Date(base);
  const startDay = d.getDate();
  d.setMonth(d.getMonth() + months);
  // clamp for end-of-month (e.g., Jan 31 -> Feb last day)
  if (d.getDate() < startDay) d.setDate(0);
  return d;
}
 /****************************************** End buildForm *****************************/
   changeEndOption(event: any) {
    this.cloneData.endOption = event?.value ?? null;
   const val = event?.value ?? null;
    const endCtrl = this.addPlanForm.get('endDateTime');
    const startVal = this.addPlanForm.get('startDateTime')!.value;
    const opt = this.getEndOpt(val);
    this.getEndDateMin();
   if( event.value == 'NEVER') {
    this.cloneData.endDateTime = null;
    this.addPlanForm.get('endDateTime')?.setValue(null);
    this.addPlanForm.get('endDateTime')?.clearValidators();
    this.addPlanForm.get('endDateTime')?.updateValueAndValidity();
   }else{
     this.addPlanForm.get('endDateTime')?.setValidators([Validators.required]);
      this.addPlanForm.get('endDateTime')?.updateValueAndValidity();

    if (opt?.calcMonths != 0 && startVal) {
      const startDate = new Date(startVal);
      const auto = this.addMonths(startDate, opt.calcMonths);
      auto.setDate(auto.getDate() - 1); // minus one day
      this.cloneData.endDateTime = auto;
      this.addPlanForm.get('endDateTime')!.setValue(auto, { emitEvent: false });
    }else{
      this.cloneData.endDateTime = null;
      this.addPlanForm.get('endDateTime')!.setValue(null, { emitEvent: false });
    }
    
   }
  }
/******************************************** On Save ******************************************/
onSubmitForm() {
  
  this.addPlanForm.markAllAsTouched();
  this.addPlanForm.updateValueAndValidity();

  // // Validate all addAssignJOForm items
  // let assignFormsValid = true;
  // this.addAssignJOForm.forEach(form => {
  //   form.markAllAsTouched();
  //   form.updateValueAndValidity();
  //   if (form.invalid) {
  //     assignFormsValid = false;
  //   }
  // });

  //console.log("Form valid status:", this.addPlanForm.valid, "Assign forms valid:", assignFormsValid);

  if (this.addPlanForm.invalid) {
    // show a toast, focus the first error, etc.
    return;
  }
  var req= {...this.cloneData};
  
  req.startDateTime = moment.tz( req.startDateTime, this.auth.getUserTimezone() );
  req.endDateTime = moment.tz( req.endDateTime, this.auth.getUserTimezone() );
 
  console.log("Submitting maintenance plan data:", req);

  this.spinner.show();

  // ...call your API
    this.preventiveMaintenanceStandaloneService.cloneMaintenancePlan(req).subscribe((res:any) => {
      console.log(res.body)
      this.spinner.hide();
      if(res.status == 201 || res.status == 200){
        //Mixpanel Event Tracking
        // if(localStorage.getItem('packageCode') != null && localStorage.getItem('packageCode') != 'Old'){
        //   this.mixPanelService.track('setup_create_location', { propertyName: 'setup_create_location', method: 'button_click'});
        // }
        localStorage.setItem("activeViewPlanIndex", '0');
       this.errorUtil.setErrorMessage(200, this.translate?.general.messages.savedSuccessfully ,  null, 'success',1000);

       this.router.routeReuseStrategy.shouldReuseRoute = () => false;
              this.router.onSameUrlNavigation = 'reload';
            this.router.navigate([this.viewUrl+'/view/'+res.body.id], {
              queryParams: { id: res.body.id },
            });

       // this.router.navigate([this.viewUrl+'/view/'+res.body.id], { queryParams : {'id' : res.body.id}});
       
      this.modalRef.hide();
      } else {
        const title = this.errorUtil.processErrorTitle(res.error,this.translate)
        this.errorUtil.setErrorMessage(res.status, null ,  title, 'error',3000);
       // this.submitTouched = false;
      }
    },
    (err) => {
      this.spinner.hide()
     const title = this.errorUtil.processErrorTitle(err.error,this.translate)
     this.errorUtil.setErrorMessage(err.status, null ,  title, 'error',3000);
    
  })
  
}
}
